import $ from "jquery";
import jQuery from "jquery";
import moment from 'moment';
import globalConfigVariables from './configs.js';
import $script from 'scriptjs';
window.$ = $;
window.jQuery = jQuery;
window.moment = moment;

var datetimepicker = require('tempusdominus-bootstrap-4');


const $processingWrapper = $(".processing");
const $alertsWrapper = $(".alert-wrapper");


function checkUserAuth(){

    var authorized = false;
    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var getStaffContextAPI = globalConfigVariables.apiDomain + 'staff/context';

    $.ajax({
        url: getStaffContextAPI,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
                signOutDashboard(401);
            }
        },
        success: function(res) {
            var permissions = res.Permissions;
            if(permissions.length){
                permissions.forEach(function(permission){
                    if(permission.Id == "38e007cc-3902-40d0-ba83-0447b9d6f8b7"){
                        authorized = true;
                    }
                });
            }
            if(!authorized){
                signOutDashboard(401);
            }
        },
    });

}


function getClients(){

    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var getClientsAPI = globalConfigVariables.apiDomain + 'admin/client-project/form-view-models';
    $.ajax({
        url: getClientsAPI,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
                signOutDashboard(401);
            }
        },
        success: function(res) {
            console.log(res);
            setClientDropdown(res.Clients);
            setLocationsDropdown(res.ClientLocations);
            setProjectStatusDropdown(res.ProjectStatuses);
        },
    });

}


function setClientDropdown(clients){

    var $selectClientDropdown = $(".select-client");

    $selectClientDropdown.html("");
    $selectClientDropdown.append('<option value="0" disabled selected>Select Client</option>');

    clients.forEach(function(client, index){
        $selectClientDropdown.append('<option value="'+client.Id+'">'+client.Name+'</option>');
    });


    $selectClientDropdown.on("change", function(event){
        var $this = $(this);
        getFolders($this.val(), $this.data("projectContext"));

        //reset the edit input fields
        clearFormFields($(".form-edit-project"));
    });


}


function setLocationsDropdown(locations){
    var $selectLocationDropdown = $(".select-location");

    $selectLocationDropdown.html("");
    $selectLocationDropdown.append('<option value="0" disabled selected>Select Location</option>');

    locations.forEach(function(location, index){
        $selectLocationDropdown.append('<option value="'+location.Id+'">'+location.Name+'</option>');
    });
}


function setProjectStatusDropdown(statuses){
    var $selectStatusDropdown = $(".select-status");

    $selectStatusDropdown.html("");
    $selectStatusDropdown.append('<option value="0" disabled selected>Select Status</option>');

    statuses.forEach(function(status, index){
        $selectStatusDropdown.append('<option value="'+status.Id+'">'+status.Name+'</option>');
    });
}


function getFolders(clientGuid, projectContext){
    //console.log("clientGuid: ", clientGuid);

    var gTokenId = localStorage.getItem('tokenId');
    var authHeader = 'bearer '+ gTokenId;
    var getFolderAPI = globalConfigVariables.apiDomain + 'admin/clients/'+clientGuid+'/folders';
    $.ajax({
        url: getFolderAPI,
        headers: {
            'Authorization': authHeader,
        },
        type: 'GET',
        dataType: 'json',
        statusCode: {
            401: function(){
                signOutDashboard(401);
            }
        },
        success: function(res) {
            console.log(res);
            setFolderDropdown(res, projectContext);
        },
    });
}


function setFolderDropdown(folders, projectContext){

    var $selectFolderDropdown;

    if(projectContext == "add"){
        $selectFolderDropdown = $(".form-add-project .select-folder");
    } else {
        $selectFolderDropdown = $(".form-edit-project .select-folder");

        //reset the edit input fields
        clearFormFields($(".form-edit-project"));
    }

    $selectFolderDropdown.html("");
    $selectFolderDropdown.append('<option value="0" disabled selected>Select Folder</option>');

    folders.forEach(function(folder, index){
        $selectFolderDropdown.append('<option value="'+folder.Id+'">'+folder.Name+'</option>');
    });

    if($selectFolderDropdown.hasClass("edit")){
        $selectFolderDropdown.on("change", function(event){
            
            var folderId = $(this).val();
            var gTokenId = localStorage.getItem('tokenId');
            var authHeader = 'bearer '+ gTokenId;
            var getProjectsAPI = globalConfigVariables.apiDomain + 'admin/folders/'+folderId+'/projects';
            $.ajax({
                url: getProjectsAPI,
                headers: {
                    'Authorization': authHeader,
                },
                type: 'GET',
                dataType: 'json',
                statusCode: {
                    401: function(){
                        signOutDashboard(401);
                    }
                },
                success: function(res) {
                    console.log(res);
                    setProjectsDropdown(res);
                },
            });

        });
    }

}


function checkJobNumber(){
    var $jobNoInput = $(".job-number");

    $jobNoInput.on("blur", function(event){

        var $this = $(this);
        var gTokenId = localStorage.getItem('tokenId');
        var authHeader = 'bearer '+ gTokenId;
        var checkJobNumberAPI = globalConfigVariables.apiDomain + 'admin/projects/job-numbers?jobNumber='+($(this).val());
        var editJobNumber = $this.data("editjobno");

        console.log("editJobNumber", editJobNumber);

        if(typeof editJobNumber === 'undefined'){
            editJobNumber = 0;
        }
        
        if(editJobNumber != $(this).val()) {

            $.ajax({
                url: checkJobNumberAPI,
                headers: {
                    'Authorization': authHeader,
                },
                type: 'GET',
                dataType: 'json',
                statusCode: {
                    401: function(){
                        signOutDashboard(401);
                    }
                },
                success: function(res) {
                    //console.log(res);
                    if(res.IsJobNumberExist == true){
                        $this.attr("data-jobnumbervalid","false");
                        $this.addClass("error");
                        $this.parent().find(".error-msg").show();
                    } else {
                        $this.attr("data-jobnumbervalid","true");
                        $this.removeClass("error");
                        $this.parent().find(".error-msg").hide();
                    }
                },
            });

        } else {
            $this.attr("data-jobnumbervalid","true");
            $this.removeClass("error");
            $this.parent().find(".error-msg").hide();
        }

    });

}


function setOpenDate(){
    $('.datetimepicker-input').datetimepicker({format: 'YYYY-MM-DD'});
}


function setProjectsDropdown(projects){
    
    var $selectProjectDropdown = $(".select-project");

    $selectProjectDropdown.html("");
    $selectProjectDropdown.append('<option value="0" disabled selected>Select Project</option>');

    projects.forEach(function(project, index){
        $selectProjectDropdown.append('<option value="'+project.Id+'" data-projectno="'+project.Number+'" data-name="'+project.Name+'" data-jobno="'+project.JobNumber+'" data-date="'+project.OpenedDate+'" data-location="'+project.ClientLocation.Id+'" data-status="'+project.ProjectStatus.Id+'" >'+project.Name+'</option>');
    });

    $selectProjectDropdown.on("change", function(event){
        setSelectedProjectInfo($(this).find(":selected").data());
    });

}


function setSelectedProjectInfo(projectData){

    console.log("projectData", projectData);

    var projectInfoWrapper = $(".form-edit-project .project-info");
    projectInfoWrapper.removeClass("d-none");

    projectInfoWrapper.find("[name='ProjectNumber']").val(projectData.projectno);
    projectInfoWrapper.find("[name='ProjectName']").val(projectData.name);
    projectInfoWrapper.find("[name='JobNumber']").val(projectData.jobno);
    projectInfoWrapper.find("[name='JobNumber']").attr("data-editjobno", projectData.jobno);
    projectInfoWrapper.find("[name='OpenedDate']").val(moment(projectData.date).format("YYYY-MM-DD"));
    projectInfoWrapper.find("[name='ClientLocationId']").val(projectData.location);
    projectInfoWrapper.find("[name='ProjectStatusId']").val(projectData.status);

}


function submitProjectForm(){

    var formAddProject = $(".form-add-project");
    var formSubmit = formAddProject.find(".form-submit");
    var formVaild = true;


    formSubmit.on("click", function(event){
        event.preventDefault();

        var formData = {};
        formVaild = true;
        formAddProject.find(":input").removeClass("error");

        formAddProject.find(":input").each(function(index, elm){
            var inputName = elm.name;
            if(inputName!==""){
                formData[inputName] = $(elm).val();
            }
        });

        for(var formInput in formData){
            if(formData.hasOwnProperty(formInput)){

                if( formData[formInput]=="" || formData[formInput]==null){
                    $('[name="'+formInput+'"]').addClass("error");
                    formVaild = false;
                }

                if(formInput=="JobNumber"){
                    if($('[name="'+formInput+'"]').attr("data-jobnumbervalid")=="false"){
                        formVaild = false;
                    }
                }

            }
        }

        //console.log("formData", formData);


        if(formVaild){
            $processingWrapper.fadeIn();

            var gTokenId = localStorage.getItem('tokenId');
            var authHeader = 'bearer '+ gTokenId;
            var addProjectAPI = globalConfigVariables.apiDomain + '/admin/projects/additions';
            formData = JSON.stringify(formData);

            $.ajax({
                url: addProjectAPI,
                headers: {
                    'Authorization': authHeader,
                },
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                data: formData,
                statusCode: {
                    200: function() {
                        clearFormFields(formAddProject);

                        $processingWrapper.fadeOut();
                        
                        $alertsWrapper.find(".context").html("added")
                        $alertsWrapper.fadeIn();

                        setTimeout(function(){
                            $alertsWrapper.fadeOut();
                        }, 1000)
                    }
                },
                success: function(res) {
                    console.log('submit success', res);
                },
            });

        }

    });
    
    formAddProject.find(":input").on("blur", function(event){
        var $this = $(this);
        if( $this.val()=="" || $this.val()==null){
        } else {
            $this.removeClass("error");
        }
    });

}


function submitProjectEditForm(){

    var formEditProject = $(".form-edit-project");
    var formSubmit = formEditProject.find(".form-submit");
    var formVaild = true;

    formSubmit.on("click", function(event){
        event.preventDefault();

        var formData = {};
        formVaild = true;
        formEditProject.find(":input").removeClass("error");

        formEditProject.find(":input").each(function(index, elm){
            var inputName = elm.name;
            if(inputName!==""){
                formData[inputName] = $(elm).val();
            }
        });

        for(var formInput in formData){
            if(formData.hasOwnProperty(formInput)){

                if( formData[formInput]=="" || formData[formInput]==null){
                    $('[name="'+formInput+'"]').addClass("error");
                    formVaild = false;
                }

                if(formInput=="JobNumber"){
                    if($('[name="'+formInput+'"]').attr("data-jobnumbervalid")=="false"){
                        formVaild = false;
                    }
                }

            }
        }

        //console.log("formData", formData);


        if(formVaild){
            $processingWrapper.fadeIn();

            var gTokenId = localStorage.getItem('tokenId');
            var authHeader = 'bearer '+ gTokenId;
            var editProjectAPI = globalConfigVariables.apiDomain + 'admin/projects/updates';
            formData = JSON.stringify(formData);

            $.ajax({
                url: editProjectAPI,
                headers: {
                    'Authorization': authHeader,
                },
                type: 'POST',
                contentType: "application/json",
                dataType: 'json',
                data: formData,
                statusCode: {
                    200: function() {
                        clearFormFields(formEditProject);

                        $processingWrapper.fadeOut();

                        $alertsWrapper.find(".context").html("updated")
                        $alertsWrapper.fadeIn();

                        setTimeout(function(){
                            $alertsWrapper.fadeOut();
                        }, 1000)

                    }
                },
                success: function(res) {
                    console.log('submit success', res);
                },
            });

        }

    });

    formEditProject.find(":input").on("blur", function(event){
        var $this = $(this);
        if( $this.val()=="" || $this.val()==null){
        } else {
            $this.removeClass("error");
        }
    });
}


function clearFormFields(form){

    if(form.hasClass("form-add-project")){
        form.find(":input").val('').prop('checked', false).prop('selected', false);
    }


    if(form.hasClass("form-edit-project")){
        form.find(".project-info").addClass("d-none");
        form.find(".project-info :input").val('').prop('checked', false).prop('selected', false);
        form.find(".project-info .select-project").prop('selected', false);
        form.find(".select-folder").html("");
        form.find(".select-project").html("");
    }

    
}


function signOutDashboard(status){

    //Check google Sign auth status
        $script.get('https://apis.google.com/js/platform.js', function () {
            gapi.load('auth2', function() {
                gapi.auth2.init().then(function(){

                    if( !(gapi.auth2.getAuthInstance().isSignedIn.get()) ){
                        window.location.replace('/index.html');
                    }

                    if(status==401){
                        gapi.auth2.getAuthInstance().signOut().then(function() {
                            localStorage.removeItem('getName');
                            console.log('User signed out.');
                            window.location.replace('/index.html');
                        });
                    }
                });
            });
        })

}


function init(){
    checkUserAuth();
    getClients();
    checkJobNumber();
    setOpenDate();
    submitProjectForm();
    submitProjectEditForm();
}

export default {
    init
}